import {
  GET_DAILYDEMAND_REQUEST,
  GET_DAILYDEMAND_SUCCESS,
  GET_DAILYDEMAND_FAILURE,
  GET_MONTHLYDEMAND_REQUEST,
  GET_MONTHLYDEMAND_SUCCESS,
  GET_MONTHLYDEMAND_FAILURE,
  UPDATE_CNF_QTY_REQUEST,
  UPDATE_CNF_QTY_SUCCESS,
  UPDATE_CNF_QTY_FAILURE,
  GET_PACKAGE_TYPE_REQUEST,
  GET_PACKAGE_TYPE_SUCCESS,
  GET_PACKAGE_TYPE_FAILURE,
  GET_PARTNO_REQUEST,
  GET_PARTNO_SUCCESS,
  GET_PARTNO_FAILURE,
  GET_PLANT_REQUEST,
  GET_PLANT_SUCCESS,
  GET_PLANT_FAILURE,
  POST_CREATEASN_FAILURE,
  POST_CREATEASN_SUCCESS,
  POST_CREATEASN_REQUEST,
  POST_CALCULATE_PACKAGE_DETAILS_REQUEST,
  POST_CALCULATE_PACKAGE_DETAILS_SUCCESS,
  POST_CALCULATE_PACKAGE_DETAILS_FAILURE,
  GET_DELIVERY_PLANT_REQUEST,
  GET_DELIVERY_PLANT_SUCCESS,
  GET_DELIVERY_PLANT_FAILURE,
  GET_UNLOADING_POINT_REQUEST,
  GET_UNLOADING_POINT_SUCCESS,
  GET_UNLOADING_POINT_FAILURE,
  GET_CALCULATE_PACKAGE_WEIGHT_REQUEST,
  GET_CALCULATE_PACKAGE_WEIGHT_SUCCESS,
  GET_CALCULATE_PACKAGE_WEIGHT_FAILURE,
  GET_BINS_FOR_PRINT_REQUEST,
  GET_BINS_FOR_PRINT_SUCCESS,
  GET_BINS_FOR_PRINT_FAILURE,
  UPLOADCSV_FOR_DAILYDEMAND_REQUEST,
  UPLOADCSV_FOR_DAILYDEMAND_SUCCESS,
  UPLOADCSV_FOR_DAILYDEMAND_FAILURE,
  UPLOADCSV_FOR_MONTHLYDEMAND_REQUEST,
  UPLOADCSV_FOR_MONTHLYDEMAND_SUCCESS,
  UPLOADCSV_FOR_MONTHLYDEMAND_FAILURE,
  UPDATE_REMARK_REQUEST,
  UPDATE_REMARK_SUCCESS,
  UPDATE_REMARK_FAILURE,
  GET_UNCONFIRMED_MONTHLYDEMAND_REQUEST,
  GET_UNCONFIRMED_MONTHLYDEMAND_SUCCESS,
  GET_UNCONFIRMED_MONTHLYDEMAND_FAILURE,
  GET_VENDORS_REQUEST,
  GET_VENDORS_SUCCESS,
  GET_VENDORS_FAILURE,
  GET_PARTNO_FOR_PLANNER_REQUEST,
  GET_PARTNO_FOR_PLANNER_SUCCESS,
  GET_PARTNO_FOR_PLANNER_FAILURE,
  UPDATE_CNF_QTY_STATUS_BY_PLANNER_REQUEST,
  UPDATE_CNF_QTY_STATUS_BY_PLANNER_SUCCESS,
  UPDATE_CNF_QTY_STATUS_BY_PLANNER_FAILURE,
  UPDATE_ACTUAL_QTY_REQUEST,
  UPDATE_ACTUAL_QTY_SUCCESS,
  UPDATE_ACTUAL_QTY_FAILURE,
  GET_VENDORS_WITH_PAGINATION_REQUEST,
  GET_VENDORS_WITH_PAGINATION_SUCCESS,
  GET_VENDORS_WITH_PAGINATION_FAILURE,
  GET_DAILYDEMAND_DOWNLOAD_REQUEST,
  GET_DAILYDEMAND_DOWNLOAD_SUCCESS,
  GET_DAILYDEMAND_DOWNLOAD_FAILURE,
  GET_MONTHLYDEMAND_DOWNLOAD_REQUEST,
  GET_MONTHLYDEMAND_DOWNLOAD_SUCCESS,
  GET_MONTHLYDEMAND_DOWNLOAD_FAILURE,
} from "./newDemandTypes";
import Config from "../../config/index";

import axios from "axios";

const URL = Config.baseUrl;

let baseUrl = Config.baseUrl;

const getDailyDemandRequest = () => {
  return {
    type: GET_DAILYDEMAND_REQUEST,
  };
};

const getDailyDemandSuccess = (payload) => {
  return {
    type: GET_DAILYDEMAND_SUCCESS,
    payload: payload,
  };
};

const getDailyDemandFailure = (error) => {
  return {
    type: GET_DAILYDEMAND_FAILURE,
    payload: error,
  };
};

const getDailyDemand = (
  userId,
  partNo,
  plant,
  vendorCode,
  roleName,
  startDate,
  endDate,
  purchaseOrderNumber,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getDailyDemandRequest());
    let url;
    if (roleName === "vendor") {
      url = `${baseUrl}/demand/get_by_vendor?email=${userId}&itemCode=${partNo}&plantCode=${plant}&startDate=${startDate}&endDate=${endDate}&purchaseOrderNumber=${purchaseOrderNumber}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    } else {
      url = `${baseUrl}/demand/get_by_planner?vendorCode=${vendorCode}&itemCode=${partNo}&plantCode=${plant}&startDate=${startDate}&endDate=${endDate}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDailyDemandSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDailyDemandFailure(err.message));
      });
  };
};

const getDailyDemandForDownloadRequest = () => {
  return {
    type: GET_DAILYDEMAND_DOWNLOAD_REQUEST,
  };
};

const getDailyDemandForDownloadSuccess = (payload) => {
  return {
    type: GET_DAILYDEMAND_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const getDailyDemandForDownloadFailure = (error) => {
  return {
    type: GET_DAILYDEMAND_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const getDailyDemandForDownload = (
  userId,
  partNo,
  plant,
  vendorCode,
  roleName,
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getDailyDemandForDownloadRequest());
    let url;
    if (roleName === "vendor") {
      url = `${baseUrl}/demand/get_by_vendor?email=${userId}&itemCode=${partNo}&plantCode=${plant}&startDate=${startDate}&endDate=${endDate}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=1`;
    } else {
      url = `${baseUrl}/demand/get_by_planner?vendorCode=${vendorCode}&itemCode=${partNo}&plantCode=${plant}&startDate=${startDate}&endDate=${endDate}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=1`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDailyDemandForDownloadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDailyDemandForDownloadFailure(err.message));
      });
  };
};

const updateActualQtyRequest = () => {
  return {
    type: UPDATE_ACTUAL_QTY_REQUEST,
  };
};

const updateActualQtySuccess = (payload) => {
  return {
    type: UPDATE_ACTUAL_QTY_SUCCESS,
    payload: payload,
  };
};

const updateActualQtyFaliure = (error) => {
  return {
    type: UPDATE_ACTUAL_QTY_FAILURE,
    payload: error,
  };
};

const updateActualQty = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateActualQtyRequest());
    let url = `${baseUrl}/demand/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateActualQtySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateActualQtyFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getMonthlyDemandRequest = () => {
  return {
    type: GET_MONTHLYDEMAND_REQUEST,
  };
};

const getMonthlyDemandSuccess = (payload) => {
  return {
    type: GET_MONTHLYDEMAND_SUCCESS,
    payload: payload,
  };
};

const getMonthlyDemandFailure = (error) => {
  return {
    type: GET_MONTHLYDEMAND_FAILURE,
    payload: error,
  };
};

const getMonthlyDemand = (
  userId,
  partNo,
  plant,
  vendorCode,
  roleName,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getMonthlyDemandRequest());
    let url;
    if (roleName === "vendor") {
      url = `${baseUrl}/monthly_demand/get?vendorId=${userId}&partCode=${partNo}&plantCode=${plant}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    } else {
      url = `${baseUrl}/monthly_demand/get_all?email=${vendorCode}&plantCode=${plant}&itemCode=${partNo}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getMonthlyDemandSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getMonthlyDemandFailure(err.message));
      });
  };
};

const getMonthlyDemandDownloadRequest = () => {
  return {
    type: GET_MONTHLYDEMAND_DOWNLOAD_REQUEST,
  };
};

const getMonthlyDemandDownloadSuccess = (payload) => {
  return {
    type: GET_MONTHLYDEMAND_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const getMonthlyDemandDownloadFailure = (error) => {
  return {
    type: GET_MONTHLYDEMAND_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const getMonthlyDemandDownload = (
  userId,
  partNo,
  plant,
  vendorCode,
  roleName,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getMonthlyDemandDownloadRequest());
    let url;
    if (roleName === "vendor") {
      url = `${baseUrl}/monthly_demand/get?vendorId=${userId}&partCode=${partNo}&plantCode=${plant}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    } else {
      url = `${baseUrl}/monthly_demand/get_all?email=${vendorCode}&plantCode=${plant}&itemCode=${partNo}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=1`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getMonthlyDemandDownloadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getMonthlyDemandDownloadFailure(err.message));
      });
  };
};

const updateCNFQtyRequest = () => {
  return {
    type: UPDATE_CNF_QTY_REQUEST,
  };
};

const updateCNFQtySuccess = (payload) => {
  return {
    type: UPDATE_CNF_QTY_SUCCESS,
    payload: payload,
  };
};

const updateCNFQtyFaliure = (error) => {
  return {
    type: UPDATE_CNF_QTY_FAILURE,
    payload: error,
  };
};

const updateCNFQty = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateCNFQtyRequest());
    let url = `${baseUrl}/monthly_demand/update_cnf_quantity`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateCNFQtySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateCNFQtyFaliure(err.message));
        return { status: false, data: err.message };
      });
  };
};

const updateRemarkRequest = () => {
  return {
    type: UPDATE_REMARK_REQUEST,
  };
};

const updateRemarkSuccess = (payload) => {
  return {
    type: UPDATE_REMARK_SUCCESS,
    payload: payload,
  };
};

const updateRemarkFaliure = (error) => {
  return {
    type: UPDATE_REMARK_FAILURE,
    payload: error,
  };
};

const updateRemark = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateRemarkRequest());
    let url = `${baseUrl}/monthly_demand/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateRemarkSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateRemarkFaliure(err.message));
        return { status: false, data: err.message };
      });
  };
};

const getPartNoForPlannerRequest = () => {
  return {
    type: GET_PARTNO_FOR_PLANNER_REQUEST,
  };
};

const getPartNoForPlannerSuccess = (payload) => {
  return {
    type: GET_PARTNO_FOR_PLANNER_SUCCESS,
    payload: payload,
  };
};

const getPartNoForPlannerFailure = (error) => {
  return {
    type: GET_PARTNO_FOR_PLANNER_FAILURE,
    payload: error,
  };
};

const getPartNoForPlanner = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPartNoForPlannerRequest());
    let url = `${baseUrl}/item`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPartNoForPlannerSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPartNoForPlannerFailure(err.message));
      });
  };
};

const getPartNoRequest = () => {
  return {
    type: GET_PARTNO_REQUEST,
  };
};

const getPartNoSuccess = (payload) => {
  return {
    type: GET_PARTNO_SUCCESS,
    payload: payload,
  };
};

const getPartNoFailure = (error) => {
  return {
    type: GET_PARTNO_FAILURE,
    payload: error,
  };
};

const getPartNo = (userId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPartNoRequest());
    let url = `${baseUrl}/vendor/get_items?email=${userId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPartNoSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPartNoFailure(err.message));
      });
  };
};

const getPlantRequest = () => {
  return {
    type: GET_PLANT_REQUEST,
  };
};

const getPlantSuccess = (payload) => {
  return {
    type: GET_PLANT_SUCCESS,
    payload: payload,
  };
};

const getPlantFailure = (error) => {
  return {
    type: GET_PLANT_FAILURE,
    payload: error,
  };
};

const getPlant = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPlantRequest());
    let url = `${baseUrl}/plant/get`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPlantSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPlantFailure(err.message));
      });
  };
};

const getVendorsListForPlannerRequest = () => {
  return {
    type: GET_VENDORS_REQUEST,
  };
};

const getVendorsListForPlannerSuccess = (payload) => {
  return {
    type: GET_VENDORS_SUCCESS,
    payload: payload,
  };
};

const getVendorsListForPlannerFailure = (error) => {
  return {
    type: GET_VENDORS_FAILURE,
    payload: error,
  };
};

const getVendorsListForPlanner = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVendorsListForPlannerRequest());
    let url = `${baseUrl}/vendor/get`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVendorsListForPlannerSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getVendorsListForPlannerFailure(err.message));
      });
  };
};

const getPackageTypeRequest = () => {
  return {
    type: GET_PACKAGE_TYPE_REQUEST,
  };
};

const getPackageTypeSuccess = (payload) => {
  return {
    type: GET_PACKAGE_TYPE_SUCCESS,
    payload: payload,
  };
};

const getPackageTypeFailure = (error) => {
  return {
    type: GET_PACKAGE_TYPE_FAILURE,
    payload: error,
  };
};

const getPackageType = (partCode, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPackageTypeRequest());
    let url = `${baseUrl}/asn/get_bin_type?itemCode=${partCode}`;
    axios
      .get(url, headers)
      .then((response) => {
        console.log("response", response);
        dispatch(getPackageTypeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPackageTypeFailure(err.message));
      });
  };
};

const getUnloadingPointRequest = () => {
  return {
    type: GET_UNLOADING_POINT_REQUEST,
  };
};

const getUnloadingPointSuccess = (payload) => {
  return {
    type: GET_UNLOADING_POINT_SUCCESS,
    payload: payload,
  };
};

const getUnloadingPointFailure = (error) => {
  return {
    type: GET_UNLOADING_POINT_FAILURE,
    payload: error,
  };
};

const getUnloadingPoint = (id, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getUnloadingPointRequest());
    let url = `${baseUrl}/asn/get_unloading_point?demandId=${id}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getUnloadingPointSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getUnloadingPointFailure(err.message));
      });
  };
};

const getDeliveryPlantRequest = () => {
  return {
    type: GET_DELIVERY_PLANT_REQUEST,
  };
};

const getDeliveryPlantSuccess = (payload) => {
  return {
    type: GET_DELIVERY_PLANT_SUCCESS,
    payload: payload,
  };
};

const getDeliveryPlantFailure = (error) => {
  return {
    type: GET_DELIVERY_PLANT_FAILURE,
    payload: error,
  };
};

const getDeliveryPlant = (id, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getDeliveryPlantRequest());
    let url = `${baseUrl}/asn/get_delivery_plant?demandId=${id}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDeliveryPlantSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDeliveryPlantFailure(err.message));
      });
  };
};

const calculatePacketDetailsRequest = () => {
  return {
    type: POST_CALCULATE_PACKAGE_DETAILS_REQUEST,
  };
};

const calculatePacketDetailsSuccess = (payload) => {
  return {
    type: POST_CALCULATE_PACKAGE_DETAILS_SUCCESS,
    payload: payload,
  };
};

const calculatePacketDetailsFaliure = (error) => {
  return {
    type: POST_CALCULATE_PACKAGE_DETAILS_FAILURE,
    payload: error,
  };
};
const calculatePacketDetails = (asnQty, partCode, userId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  let payload = {
    asnQty: asnQty,
    itemCode: partCode,
    email: userId,
  };

  return (dispatch) => {
    dispatch(calculatePacketDetailsRequest());
    let url = `${baseUrl}/asn/calculate_qty_of_packets`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(calculatePacketDetailsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(calculatePacketDetailsFaliure(err.message));
        return { status: false };
      });
  };
};

const calculatePacketWeightRequest = () => {
  return {
    type: GET_CALCULATE_PACKAGE_WEIGHT_REQUEST,
  };
};

const calculatePacketWeightSuccess = (payload) => {
  return {
    type: GET_CALCULATE_PACKAGE_WEIGHT_SUCCESS,
    payload: payload,
  };
};

const calculatePacketWeightFaliure = (error) => {
  return {
    type: GET_CALCULATE_PACKAGE_WEIGHT_FAILURE,
    payload: error,
  };
};

const calculatePacketWeight = (partCode, asnQty, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(calculatePacketWeightRequest());
    let url = `${baseUrl}/asn/calculate_weight?itemCode=${partCode}&asnQty=${asnQty}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(calculatePacketWeightSuccess(response.data));
      })
      .catch((err) => {
        dispatch(calculatePacketWeightFaliure(err.message));
      });
  };
};

const createAsnRequest = () => {
  return {
    type: POST_CREATEASN_REQUEST,
  };
};

const createAsnSuccess = (payload) => {
  return {
    type: POST_CREATEASN_SUCCESS,
    payload: payload,
  };
};

const createAsnFaliure = (error) => {
  return {
    type: POST_CREATEASN_FAILURE,
    payload: error,
  };
};
const createAsn = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  let data = new FormData();

  data.append("testCertificate", payload.testCertificate);
  data.append("invoice", payload.invoice);
  data.append("invoiceNo", payload.invoiceNo);
  data.append("invoiceDate", payload.invoiceDate);
  data.append("planDate", payload.planDate);
  data.append("demandId", payload.demandId);
  data.append("itemCodeDes", payload.partNoDes);
  data.append("poNoLineNo", payload.poNoLineNo);
  data.append("asnQty", payload.asnQty);
  data.append("packageType", payload.packageType);
  data.append("packetNo", payload.packetNo);
  data.append("packetWeight", payload.packetWeight);
  data.append("unloadingPoint", payload.unloadingPoint);
  data.append("deliveryPlant", payload.deliveryPlant);
  data.append("email", payload.email);

  return (dispatch) => {
    dispatch(createAsnRequest());
    let url = `${baseUrl}/asn/create`;
    return axios
      .post(url, data, headers)
      .then((response) => {
        dispatch(createAsnSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createAsnFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getBinsForPrintRequest = () => {
  return {
    type: GET_BINS_FOR_PRINT_REQUEST,
  };
};

const getBinsForPrintSuccess = (payload) => {
  return {
    type: GET_BINS_FOR_PRINT_SUCCESS,
    payload: payload,
  };
};

const getBinsForPrintFailure = (error) => {
  return {
    type: GET_BINS_FOR_PRINT_FAILURE,
    payload: error,
  };
};

const getBinsForPrint = (asnCode, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getBinsForPrintRequest());

    let url = `${baseUrl}/asn/get_temp_bin?asnCode=${asnCode}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getBinsForPrintSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getBinsForPrintFailure(err.message));
      });
  };
};

const uploadCsvForDailyDemandRequest = () => {
  return {
    type: UPLOADCSV_FOR_DAILYDEMAND_REQUEST,
  };
};

const uploadCsvForDailyDemandSuccess = (payload) => {
  return {
    type: UPLOADCSV_FOR_DAILYDEMAND_SUCCESS,
    payload: payload,
  };
};

const uploadCsvForDailyDemandFailure = (error) => {
  return {
    type: UPLOADCSV_FOR_DAILYDEMAND_FAILURE,
    payload: error,
  };
};

const uploadCsvForDailyDemand = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadCsvForDailyDemandRequest());
    let url = `${baseUrl}/direct_demand/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForDailyDemandSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForDailyDemandFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const uploadCsvForMonthlyDemandRequest = () => {
  return {
    type: UPLOADCSV_FOR_MONTHLYDEMAND_REQUEST,
  };
};

const uploadCsvForMonthlyDemandSuccess = (payload) => {
  return {
    type: UPLOADCSV_FOR_MONTHLYDEMAND_SUCCESS,
    payload: payload,
  };
};

const uploadCsvForMonthlyDemandFailure = (error) => {
  return {
    type: UPLOADCSV_FOR_MONTHLYDEMAND_FAILURE,
    payload: error,
  };
};

const uploadCsvForMonthlyDemand = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadCsvForMonthlyDemandRequest());
    let url = `${baseUrl}/monthly_demand/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForMonthlyDemandSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForMonthlyDemandFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getUnConfirmedMonthlyDemandRequest = () => {
  return {
    type: GET_UNCONFIRMED_MONTHLYDEMAND_REQUEST,
  };
};

const getUnConfirmedMonthlyDemandSuccess = (payload) => {
  return {
    type: GET_UNCONFIRMED_MONTHLYDEMAND_SUCCESS,
    payload: payload,
  };
};

const getUnConfirmedMonthlyDemandFailure = (error) => {
  return {
    type: GET_UNCONFIRMED_MONTHLYDEMAND_FAILURE,
    payload: error,
  };
};

const getUnConfirmedMonthlyDemand = (userId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getUnConfirmedMonthlyDemandRequest());

    let url = `${baseUrl}/monthly_demand/get_unchanged?vendorId=${userId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getUnConfirmedMonthlyDemandSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getUnConfirmedMonthlyDemandFailure(err.message));
      });
  };
};

const updateCnfQtyStatusByPlannerRequest = () => {
  return {
    type: UPDATE_CNF_QTY_STATUS_BY_PLANNER_REQUEST,
  };
};

const updateCnfQtyStatusByPlannerSuccess = (payload) => {
  return {
    type: UPDATE_CNF_QTY_STATUS_BY_PLANNER_SUCCESS,
    payload: payload,
  };
};

const updateCnfQtyStatusByPlannerFaliure = (error) => {
  return {
    type: UPDATE_CNF_QTY_STATUS_BY_PLANNER_FAILURE,
    payload: error,
  };
};

const updateCnfQtyStatusByPlanner = (id, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateCnfQtyStatusByPlannerRequest());
    let url = `${baseUrl}/monthly_demand/enable_qty_update?id=${id}`;
    return axios
      .put(url, {}, headers)
      .then((response) => {
        dispatch(updateCnfQtyStatusByPlannerSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateCnfQtyStatusByPlannerFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};
const getVendorsListForPlannerWithPaginationRequest = () => {
  return {
    type: GET_VENDORS_WITH_PAGINATION_REQUEST,
  };
};

const getVendorsListForPlannerWithPaginationSuccess = (payload) => {
  return {
    type: GET_VENDORS_WITH_PAGINATION_SUCCESS,
    payload: payload,
  };
};

const getVendorsListForPlannerWithPaginationFailure = (error) => {
  return {
    type: GET_VENDORS_WITH_PAGINATION_FAILURE,
    payload: error,
  };
};

const getVendorsListForPlannerWithPagination = (
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVendorsListForPlannerWithPaginationRequest());
    let url = `${baseUrl}/vendor/get_by_pagination?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVendorsListForPlannerWithPaginationSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getVendorsListForPlannerWithPaginationFailure(err.message));
      });
  };
};
export {
  getDailyDemand,
  getDailyDemandForDownload,
  getMonthlyDemand,
  getPartNoForPlanner,
  getPartNo,
  getPlant,
  updateCNFQty,
  createAsn,
  getPackageType,
  calculatePacketDetails,
  getUnloadingPoint,
  getDeliveryPlant,
  calculatePacketWeight,
  getBinsForPrint,
  uploadCsvForDailyDemand,
  uploadCsvForMonthlyDemand,
  updateRemark,
  getUnConfirmedMonthlyDemand,
  getVendorsListForPlanner,
  getVendorsListForPlannerWithPagination,
  updateCnfQtyStatusByPlanner,
  updateActualQty,
  getMonthlyDemandDownload,
};
